// src/components/InspectionHub.js - VERSION CORRIGÉE

import React, { useState, useEffect } from 'react';
import './InspectionHub.css';
import inspectionStorage from '../services/inspectionStorage';
import referentielService from '../services/referentielService';
import apiService from '../services/apiService';
import cloneManager from '../services/cloneManager';  // ✅ AJOUTÉ
import { useRapportMeta } from '../hooks/useRapportMeta';
import Etape1 from './Etape1';
import Etape2 from './Etape2';
import Etape3 from './Etape3';
import Etape4 from './Etape4';
import Etape5 from './Etape5';
import Etape6 from './Etape6';
import Etape7 from './Etape7';
import Etape8 from './Etape8';
import Etape9 from './Etape9';
import Etape10 from './Etape10';
import Etape11 from './Etape11';
import Etape13 from './Etape13';
import Etape15 from './Etape15Q18';
import Etape16ERP from './Etape16ERP';
import Etape17ERPSynthese from './Etape17ERPSynthese';
import Etape14Temporaire from './Etape14Temporaire';
import Etape18CaracteristiquesERPMobile from './Etape18CaracteristiquesERPMobile';
import Etape19MaterielsMesureMobile from './Etape19MaterielsMesureMobile';
import Etape20AvisConformiteRVRATMobile from './Etape20AvisConformiteRVRATMobile';


function InspectionHub({ mission, onBack, onStepClick, onGoHome }) {
  const [progress, setProgress] = useState({ completed: 0, total: 14, percentage: 0 });
  const [unsyncedChanges, setUnsyncedChanges] = useState(false);
  const [currentStep, setCurrentStep] = useState(null);
  const [stepsStatus, setStepsStatus] = useState({});
  const [isLoadingReferentiel, setIsLoadingReferentiel] = useState(false);
  const [referentielError, setReferentielError] = useState(null);
  const [isSyncing, setIsSyncing] = useState(false);
  const [isValidating, setIsValidating] = useState(false);

  const { rapportTitle, applySyncResult, validateRapport, showValidateButton } = useRapportMeta(
    mission.id,
  );
  
  // 🔥 États pour les options conditionnelles (lus depuis storage local)
  const [inclureQ18, setInclureQ18] = useState(mission.inclure_q18 || false);
  const [inclureERP, setInclureERP] = useState(mission.inclure_erp || false);
  const [typeVerification, setTypeVerification] = useState(mission.type_verification || '');
  const [typeRapportTemporaire, setTypeRapportTemporaire] = useState(mission.type_rapport_temporaire || 'complet');
  
  // 🔥 Détection du type de rapport - basée sur l'état local
  const isTemporaire = typeVerification === 'Installation temporaire (R4226-21)' || 
                       typeVerification?.includes('temporaire') ||
                       typeVerification?.includes('R4226-21');
  
  const isRVRAT = typeVerification === 'Vérification après travaux ERP 1er groupe (RVRAT)' ||
                  typeVerification?.includes('RVRAT');

  const isTemporaireSimplifie = isTemporaire && typeRapportTemporaire === 'simplifie';

  // Liste des étapes de base pour rapport STANDARD
  const standardSteps = [
    { key: 'etape_1_infos_generales', label: 'Informations générales', icon: '📋', component: Etape1 },
    { key: 'etape_2_normes', label: 'Normes et réglementations', icon: '📖', component: Etape2 },
    { key: 'etape_3_conditions', label: 'Conditions de vérification', icon: '🔧', component: Etape3 },
    { key: 'etape_4_documents', label: 'Documents présentés', icon: '📄', component: Etape4 },
    { key: 'etape_5_prises_terre', label: 'Prises de terre', icon: '⚡', component: Etape5 },
    { key: 'etape_7_classification', label: 'Classification des locaux', icon: '🏢', component: Etape6 },
    { key: 'etape_8_securite', label: 'Installations de sécurité', icon: '🛡️', component: Etape7 },
    { key: 'etape_6_sources_energie', label: 'Sources d\'énergie', icon: '⚡', component: Etape8 },
    { key: 'etape_9_armoires', label: 'Armoires électriques', icon: '⚡', component: Etape9 },
    { key: 'etape_10_localisations', label: 'Localisations et équipements', icon: '📍', component: Etape10 },
    { key: 'etape_11_observations', label: 'Observations', icon: '⚠️', component: Etape11 },
    { key: 'etape_12_observations_annexes', label: 'Observations Annexes', icon: '📋', component: null },
    { key: 'etape_13_finalisation', label: 'Finalisation et photos', icon: '📸', component: Etape13 }
  ];
  
  // 🔥 Liste des étapes pour rapport RVRAT (Vérification après travaux ERP 1er groupe)
  const rvratSteps = [
    { key: 'etape_1_infos_generales', label: 'Informations générales', icon: '📋', component: Etape1 },
    { key: 'etape_18_caracteristiques_erp', label: 'Caractéristiques ERP', icon: '🏛️', component: Etape18CaracteristiquesERPMobile },
    { key: 'etape_3_conditions', label: 'Conditions de vérification', icon: '🔧', component: Etape3 },
    { key: 'etape_4_documents', label: 'Documents présentés', icon: '📄', component: Etape4 },
    { key: 'etape_6_sources_energie', label: 'Sources d\'énergie', icon: '⚡', component: Etape8 },
    { key: 'etape_8_securite', label: 'Éclairage de sécurité', icon: '🛡️', component: Etape7 },
    { key: 'etape_19_materiels_mesure', label: 'Matériels de mesure', icon: '🔧', component: Etape19MaterielsMesureMobile },
    { key: 'etape_20_avis_conformite_rvrat', label: 'Avis de conformité', icon: '✅', component: Etape20AvisConformiteRVRATMobile },
    { key: 'etape_11_observations', label: 'Observations', icon: '⚠️', component: Etape11 },
    { key: 'etape_13_finalisation', label: 'Finalisation et photos', icon: '📸', component: Etape13 }
  ];

  // 🔥 Liste des étapes pour rapport TEMPORAIRE (R4226-21) - simplifié
  const temporaireSteps = [
    { key: 'etape_1_infos_generales', label: 'Informations générales', icon: '📋', component: Etape1 },
    { key: 'etape_3_conditions', label: 'Conditions de vérification', icon: '🔧', component: Etape3 },
    { key: 'etape_5_prises_terre', label: 'Prises de terre et LEP', icon: '⚡', component: Etape5 },
    { key: 'etape_7_classification', label: 'Classification des locaux', icon: '🏢', component: Etape6 },
    { key: 'etape_8_securite', label: 'Installations de sécurité', icon: '🛡️', component: Etape7 },
    { key: 'etape_6_sources_energie', label: 'Sources d\'énergie', icon: '⚡', component: Etape8 },
    { key: 'etape_9_armoires', label: 'Armoires électriques', icon: '⚡', component: Etape9 },
    { key: 'etape_10_localisations', label: 'Localisations et équipements', icon: '📍', component: Etape10 },
    { key: 'etape_11_observations', label: 'Observations', icon: '⚠️', component: Etape11 },
    { key: 'etape_13_finalisation', label: 'Finalisation et photos', icon: '📸', component: Etape13 },
    { key: 'etape_14_points_examines_temporaires', label: 'Points examinés', icon: '✅', component: Etape14Temporaire }
  ];
  
  // Sélectionner les étapes de base selon le type de rapport
  const baseSteps = isRVRAT
    ? rvratSteps
    : (isTemporaireSimplifie
        ? temporaireSteps
        : (isTemporaire
            ? [...standardSteps, { key: 'etape_14_points_examines_temporaires', label: 'Points examinés', icon: '✅', component: Etape14Temporaire }]
            : standardSteps));

  // Étapes conditionnelles (uniquement pour les rapports standards)
  const q18Step = { key: 'etape_15_Q18', label: 'Annexe Q18 (Incendie/Explosion)', icon: '🔥', component: Etape15 };
  const erpSteps = [
    { key: 'etape_16_erp', label: 'Informations ERP', icon: '🏛️', component: Etape16ERP },
    { key: 'etape_17_erp_synthese', label: 'Synthèse ERP', icon: '📊', component: Etape17ERPSynthese }
  ];

  // 🔥 Construction dynamique basée sur les états locaux
  const steps = [
    ...baseSteps,
    ...(!isTemporaire && inclureQ18 ? [q18Step] : []),
    ...(!isTemporaire && inclureERP ? erpSteps : [])
  ];

  useEffect(() => {
    loadProgress();
    checkUnsyncedChanges();
    loadStepsStatus();
    initReferentiel();
    loadOptionsFromStorage(); // 🔥 Charger les options au démarrage
  }, [mission.id]);

  useEffect(() => {
    loadProgress();
    loadStepsStatus();
  }, [steps.length, typeRapportTemporaire, typeVerification]);

  // 🔥 Charger les options Q18/ERP et type de vérification depuis le storage local (étape 1)
  const loadOptionsFromStorage = async () => {
    try {
      const etape1Data = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales');
      if (etape1Data) {
        if (etape1Data.inclure_q18 !== undefined) setInclureQ18(etape1Data.inclure_q18);
        if (etape1Data.inclure_erp !== undefined) setInclureERP(etape1Data.inclure_erp);
        if (etape1Data.type_verification) setTypeVerification(etape1Data.type_verification);
        if (etape1Data.type_rapport_temporaire) setTypeRapportTemporaire(etape1Data.type_rapport_temporaire);
        console.log('📦 Options chargées - Q18:', etape1Data.inclure_q18, 'ERP:', etape1Data.inclure_erp, 'Type:', etape1Data.type_verification, 'Temporaire:', etape1Data.type_rapport_temporaire);
      }
    } catch (error) {
      console.error('❌ Erreur chargement options:', error);
    }
  };

  const initReferentiel = async () => {
    try {
      // ✅ CORRECTION : Utiliser cloneManager
      const token = cloneManager.getToken();
      
      if (!token) {
        console.warn('⚠️ Pas de token API trouvé, référentiel non chargé');
        return;
      }

      const stats = await referentielService.getCacheStats();
      
      if (stats && stats.exists && !stats.expired) {
        console.log(`✅ Référentiel en cache (${stats.ageDays} jours, ${stats.count} observations)`);
        return;
      }

      console.log('📡 Chargement du référentiel des observations...');
      setIsLoadingReferentiel(true);
      setReferentielError(null);
      
      const referentiel = await referentielService.getReferentiel();
      
      console.log('✅ Référentiel chargé et mis en cache !', {
        total: referentiel.length,
        observations: referentiel.length
      });
      
      setIsLoadingReferentiel(false);

    } catch (error) {
      console.error('❌ Erreur chargement référentiel:', error);
      setReferentielError(error.message);
      setIsLoadingReferentiel(false);
    }
  };

  const loadProgress = async () => {
    const prog = await inspectionStorage.getProgress(mission.id);
    setProgress({
      ...prog,
      total: steps.length
    });
  };

  const checkUnsyncedChanges = async () => {
    const inspection = await inspectionStorage.getInspection(mission.id);
    setUnsyncedChanges(inspection && !inspection.synced);
  };

  const loadStepsStatus = async () => {
    const status = {};
    for (const step of steps) {
      const stepData = await inspectionStorage.getStep(mission.id, step.key);
      status[step.key] = stepData ? 'completed' : 'pending';
    }
    setStepsStatus(status);
  };

  const handleStepClick = (step) => {
    if (step.component) {
      setCurrentStep(step);
    } else {
      alert(`🚧 Formulaire "${step.label}" en cours de développement\n\nÉtape : ${step.key}`);
    }
  };

  const handleBackFromStep = () => {
    setCurrentStep(null);
    loadProgress();
    loadStepsStatus();
    checkUnsyncedChanges();
    loadOptionsFromStorage(); // 🔥 Recharger les options après retour
  };

  const handleStepSave = async (data) => {
    console.log('✅ Étape sauvegardée:', data);
    await loadProgress();
    await loadStepsStatus();
    await checkUnsyncedChanges();
    await loadOptionsFromStorage(); // 🔥 Recharger les options après sauvegarde
  };

  const handleSave = async () => {
    alert('💾 Données sauvegardées localement');
  };

  const handleSync = async () => {
    try {
      console.log('🔍 ========================================');
      console.log('🔍 INSPECTIONHUB - SYNC');
      console.log('🔍 ========================================');
      
      // ✅ CORRECTION : Utiliser cloneManager
      const token = cloneManager.getToken();
      const clone = cloneManager.getClone();
      
      console.log('🔍 Token présent:', !!token);
      console.log('🔍 Clone:', clone);
      console.log('🔍 API URL:', clone?.api_url);
      console.log('🔍 Clone ID:', clone?.clone_id);
      
      if (!token) {
        console.error('❌ ========================================');
        console.error('❌ PAS DE TOKEN !');
        console.error('❌ ========================================');
        console.error('❌ Clone:', clone);
        alert('❌ Vous devez être connecté pour synchroniser.\n\nVeuillez vous déconnecter et vous reconnecter.');
        return;
      }

      console.log('✅ Token trouvé, début de la sync...');
      setIsSyncing(true);

      // 🔥 Récupérer TOUTES les données stockées pour cette mission (pas seulement les steps affichés)
      const allStoredData = await inspectionStorage.getAllSteps(mission.id);
      
      // 🔥 DEBUG: Afficher toutes les clés stockées
      console.log('🔍 Clés stockées pour mission', mission.id, ':', Object.keys(allStoredData));
      
      // Filtrer les données pertinentes (exclure meta et sync_status)
      const allData = {};
      for (const [key, value] of Object.entries(allStoredData)) {
        if (key !== 'meta' && key !== 'sync_status' && !key.includes('synced_at')) {
          allData[key] = value;
        }
      }
      
      // 🔥 DEBUG: Afficher les données qui vont être envoyées
      console.log('📤 Données à synchroniser:', Object.keys(allData));
      if (allData.etape_20_avis_conformite_rvrat) {
        console.log('✅ etape_20_avis_conformite_rvrat PRÉSENT:', allData.etape_20_avis_conformite_rvrat);
      } else {
        console.log('❌ etape_20_avis_conformite_rvrat ABSENT');
      }

      if (Object.keys(allData).length === 0) {
        alert('ℹ️ Aucune donnée à synchroniser');
        setIsSyncing(false);
        return;
      }

      console.log('📤 Envoi des données vers Base44...', allData);

      const result = await apiService.syncMissionData(mission.id, allData);

      if (result.success) {
        await inspectionStorage.markAsSynced(mission.id);
        await applySyncResult(result);
        setUnsyncedChanges(false);
        alert('✅ Synchronisation réussie !\n\nDonnées envoyées à Base44.');
      } else {
        alert('❌ Erreur de synchronisation:\n' + (result.error || 'Erreur inconnue'));
      }

    } catch (error) {
      console.error('❌ ========================================');
      console.error('❌ ERREUR SYNC');
      console.error('❌ ========================================');
      console.error('❌ Erreur:', error);
      console.error('❌ Message:', error.message);
      console.error('❌ Stack:', error.stack);
      alert('❌ Erreur de synchronisation:\n' + error.message);
    } finally {
      setIsSyncing(false);
    }
  };

  const handleValidateRapport = async () => {
    setIsValidating(true);
    try {
      const r = await validateRapport();
      if (r?.success && !r.alreadyValid) {
        alert('✅ Rapport validé. Numéro chrono enregistré.');
      }
    } finally {
      setIsValidating(false);
    }
  };

  // Si une étape est ouverte, afficher le composant de l'étape
  if (currentStep && currentStep.component) {
    const StepComponent = currentStep.component;
    return (
      <StepComponent
        mission={mission}
        onBack={handleBackFromStep}
        onSave={handleStepSave}
      />
    );
  }

  return (
    <div className="inspection-hub">
      {/* Indicateur de chargement du référentiel */}
      {isLoadingReferentiel && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: '#3b82f6',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '3px solid white',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>Téléchargement du référentiel...</span>
        </div>
      )}

      {/* Indicateur de synchronisation */}
      {isSyncing && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: '#10b981',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '3px solid white',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <span>Synchronisation en cours...</span>
        </div>
      )}

      {/* Erreur de chargement du référentiel */}
      {referentielError && (
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          background: '#ef4444',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 9999,
          fontSize: '14px',
          fontWeight: '600'
        }}>
          ⚠️ Erreur référentiel : {referentielError}
        </div>
      )}

      {/* Header */}
      <div className="inspection-header">
        <button type="button" className="back-button" onClick={onBack}>
          ← Retour
        </button>
        <h1>Inspection</h1>
        {typeof onGoHome === 'function' ? (
          <button type="button" className="home-nav-button" onClick={onGoHome}>
            Accueil
          </button>
        ) : (
          <div />
        )}
      </div>

      {/* Mission Info */}
      <div className="mission-info-card">
        <div className="mission-info-header">
          <h2>{rapportTitle}</h2>
          {unsyncedChanges && (
            <span className="unsynced-badge">
              🔄 Non synchronisé
            </span>
          )}
        </div>
        <p className="mission-client">{mission.client_nom}</p>
        <p className="mission-address">{mission.site_adresse}</p>
        
        {/* Badges options - utilise les états locaux */}
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
          {isTemporaire && (
            <span style={{ 
              padding: '6px 12px', 
              background: 'linear-gradient(135deg, #f59e0b, #d97706)', 
              color: 'white', 
              borderRadius: '12px', 
              fontSize: '11px', 
              fontWeight: 600 
            }}>
              ⚡ Installation Temporaire (R4226-21)
            </span>
          )}
          {isRVRAT && (
            <span style={{ 
              padding: '6px 12px', 
              background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', 
              color: 'white', 
              borderRadius: '12px', 
              fontSize: '11px', 
              fontWeight: 600 
            }}>
              🏛️ RVRAT - ERP 1er groupe
            </span>
          )}
          {!isTemporaire && inclureQ18 && (
            <span style={{ padding: '4px 10px', background: '#fef3c7', color: '#92400e', borderRadius: '12px', fontSize: '11px', fontWeight: 600 }}>
              🔥 Q18
            </span>
          )}
          {!isTemporaire && inclureERP && (
            <span style={{ padding: '4px 10px', background: '#e0e7ff', color: '#3730a3', borderRadius: '12px', fontSize: '11px', fontWeight: 600 }}>
              🏛️ ERP
            </span>
          )}
        </div>
      </div>

      {/* Progress */}
      <div className="progress-card">
        <div className="progress-header">
          <span className="progress-label">Progression</span>
          <span className="progress-value">
            {progress.completed}/{steps.length} ({Math.round((progress.completed / steps.length) * 100)}%)
          </span>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${(progress.completed / steps.length) * 100}%` }}
          ></div>
        </div>
      </div>

      {/* Steps List */}
      <div className="steps-container">
        <h3 className="steps-title">Étapes de vérification</h3>
        
        <div className="steps-list">
          {steps.map((step, index) => {
            const status = stepsStatus[step.key] || 'pending';

            return (
              <div
                key={step.key}
                className={`step-item ${status}`}
                onClick={() => handleStepClick(step)}
              >
                <div className="step-number">{index + 1}</div>
                <div className="step-icon">{step.icon}</div>
                <div className="step-content">
                  <div className="step-label">{step.label}</div>
                  <div className="step-key">{step.key}</div>
                </div>
                <div className="step-status">
                  {status === 'completed' ? '✅' : 
                   status === 'in-progress' ? '⏳' : '⬜'}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Actions */}
      <div className="inspection-actions">
        <button className="action-button secondary" onClick={handleSave}>
          💾 Sauvegarder localement
        </button>
        {showValidateButton && (
          <button
            type="button"
            className="action-button primary"
            style={{ background: 'linear-gradient(135deg, #059669, #047857)' }}
            onClick={handleValidateRapport}
            disabled={isValidating || !navigator.onLine}
          >
            {isValidating ? '⏳ Validation…' : '✅ Valider le rapport (chrono)'}
          </button>
        )}
        <button 
          className="action-button primary" 
          onClick={handleSync}
          disabled={isSyncing}
        >
          {isSyncing ? '⏳ Synchronisation...' : '🔄 SYNCHRO avec RAPTECK APP'}
        </button>
      </div>

      {/* Info */}
      <div className="inspection-info">
        <p>💡 Les données sont sauvegardées automatiquement sur votre appareil</p>
        <p>🔄 Synchronisez pour envoyer les données à Base44</p>
      </div>
    </div>
  );
}

export default InspectionHub;